import React, { FC } from 'react'

import { ControlInputProps } from './_types'
import * as S from './ButtonGroup.styles'

export const ControlButton: FC<ControlInputProps> = ({
  multipleSelect,
  onClick,
  id,
  value,
  defaultChecked,
  checked,
  name,
  disabled,
  children,
  title,
  dataCy,
  rectangular = false,
  className,
}) => {
  const _id = id || `${name}_${value}`

  return (
    <S.Container rectangular={rectangular} className={className}>
      <S.HiddenControlInput
        type={multipleSelect ? 'checkbox' : 'radio'}
        onClick={onClick}
        id={_id}
        value={value || ''}
        defaultChecked={defaultChecked}
        checked={checked}
        name={name}
        disabled={disabled}
        readOnly
        data-cy={dataCy}
      />

      <S.ControlDefault
        htmlFor={_id}
        defaultChecked={checked}
        disabled={disabled}
        rectangular={rectangular}
      >
        {title ? <S.Title>{title}</S.Title> : null}
        {children ? <S.ControlChildren noMargin={!title}>{children}</S.ControlChildren> : null}
      </S.ControlDefault>
    </S.Container>
  )
}
